import {toast} from '@/componentLibrary/components/Toast/toast';
import {userLinks} from '@/pages/User/links';

export function displayErrorMessage() {
    toast({type: 'error'});
}
export function getJobApplicationLink(organizationId: number) {
    return userLinks.jobApplication(organizationId);
}
